import { Megaphone, Video, Mic, CalendarClock, Bot } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export function Features() {
  const { t } = useI18n();
  const features = [
    { icon: Megaphone, title: t("features.ads.title"), desc: t("features.ads.desc") },
    { icon: Video, title: t("features.video.title"), desc: t("features.video.desc") },
    { icon: Mic, title: t("features.voice.title"), desc: t("features.voice.desc") },
    { icon: CalendarClock, title: t("features.social.title"), desc: t("features.social.desc") },
    { icon: Bot, title: t("features.leadagent.title"), desc: t("features.leadagent.desc") },
  ];
  return (
    <section id="features" className="py-24 px-6 scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-sm uppercase tracking-[0.2em] text-primary mb-3">{t("features.eyebrow")}</p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">{t("features.title.1")} <span className="text-gradient-orange">{t("features.title.2")}</span></h2>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          {features.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="group relative p-8 rounded-3xl bg-card border border-border hover:border-primary/40 transition overflow-hidden">
              <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full blur-3xl opacity-20 bg-primary" />
              <div className="relative w-14 h-14 rounded-2xl flex items-center justify-center mb-6 bg-primary/15">
                <Icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-2xl font-bold mb-3">{title}</h3>
              <p className="text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
